<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
    <g fill="none" fill-rule="evenodd">
        <g fill="#000">
            <g>
                <path class="fill" d="M32 45.333c2.946 0 5.333 2.388 5.333 5.334C37.333 53.612 34.946 56 32 56s-5.333-2.388-5.333-5.333c0-2.946 2.387-5.334 5.333-5.334zM32 28c2.946 0 5.333 2.388 5.333 5.333 0 2.946-2.387 5.334-5.333 5.334s-5.333-2.388-5.333-5.334C26.667 30.388 29.054 28 32 28zm0-17.333c2.946 0 5.333 2.387 5.333 5.333S34.946 21.333 32 21.333 26.667 18.946 26.667 16s2.387-5.333 5.333-5.333z" transform="translate(-1074 -751) translate(1074 751)"/>
            </g>
        </g>
    </g>
</svg>
